import { css } from '@emotion/react'
import ClipLoader from 'react-spinners/ClipLoader'
import { baseColor } from '../../../../lib/styles/colors'

const loadingContainerCss = css`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Loading = () => (
  <div css={loadingContainerCss} role="status" aria-label="Loading">
    <ClipLoader color={baseColor} loading size={75} />
  </div>
)

export default Loading
